var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingLists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.5,
    height: 87.5,
    viewBox: "0 0 112.5 87.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.5,42.188v3.125A4.687,4.687,0,0,1,107.813,50H106.25l-5.1,35.7a9.375,9.375,0,0,1-9.281,8.049H20.631A9.375,9.375,0,0,1,11.35,85.7L6.25,50H4.688A4.687,4.687,0,0,1,0,45.313V42.188A4.687,4.687,0,0,1,4.688,37.5H17.84L38.7,8.824A6.25,6.25,0,0,1,48.8,16.176L33.3,37.5H79.2L63.7,16.176A6.25,6.25,0,0,1,73.8,8.824L94.66,37.5h13.153A4.687,4.687,0,0,1,112.5,42.188ZM60.938,76.563V54.688a4.688,4.688,0,0,0-9.375,0V76.563a4.688,4.688,0,0,0,9.375,0Zm21.875,0V54.688a4.688,4.688,0,0,0-9.375,0V76.563a4.688,4.688,0,0,0,9.375,0Zm-43.75,0V54.688a4.688,4.688,0,0,0-9.375,0V76.563a4.688,4.688,0,0,0,9.375,0Z",
    transform: "translate(0 -6.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingLists);
export default __webpack_public_path__ + "static/media/shopping-lists.3a3b5d4be27f0658200c281528fc3d88.svg";
export { ForwardRef as ReactComponent };